import React, { Fragment } from 'react';
import { getEnumObjectProp } from '../../../../utils';
import CustomSelect from '../../CustomSelect';

const FilterContainerCriteria = (props) => {
  const { filterAttributes, onChange, enums, t, criteria } = props || {},
    { Placeholders } = t || {};

  return (
    <Fragment>
      <CustomSelect
        name={'criteria'}
        label={Placeholders.criteria}
        data={filterAttributes}
        textExtractor={(a) => getEnumObjectProp(enums, a)}
        valueExtractor={(a) => getEnumObjectProp(enums, a, 'value')}
        value={criteria}
        className={`background-white`}
        onChange={onChange}
      />
    </Fragment>
  );
};

export default FilterContainerCriteria;
